
import { ApiBase } from "./base";

export class DiscoveryApi extends ApiBase {

  settings: ApiSettings = {
    apiKey: 'iw',
    apiSecret: 'gsvlabs',
    //@ts-ignore
    apiEndpoint: process.env.NEXT_PUBLIC_DISCOVERY_URI ? process.env.NEXT_PUBLIC_DISCOVERY_URI : 'https://ft45cm83v6.execute-api.us-west-2.amazonaws.com/prod'
  };

  static accessTokenVariableName: string = 'accessToken';
  static sessionTokenVariableName: string = 'sessionToken';

  useBasicAuth = true;

  // TODO: This needs to live in a jenkins esc configuration
  static stripeKey: string = "";

  constructor() {
    super();
    DiscoveryApi.stripeKey =
      process.env.NEXT_PUBLIC_STRIPE_KEY || "pk_live_wENZoSEciiEUe8dNxHfxJUSY";
  }

  artifactURL(url: string) {
    if (!url) return;

    if (url.indexOf("?") > -1) {
      return (url = url + "&auth=" + this.authToken());
    } else {
      return (url = url + "?auth=" + this.authToken());
    }
  }
}

export default new DiscoveryApi();
